import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IBOMSetupOnboardPostBody, IBOMSetupOnboardPostResponse } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useBOMSetupOnboardAPI = () => {
  const [_bom_id, setBom_id] = useState<string>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: IBOMSetupOnboardPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(INVENTORY_MODULE?.BOM_SETUP_ONBOARD_API?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBOMSetupOnboardPostResponse>) => {
            if (res.data.status === true) {
              setBom_id(res.data.data.bom_id);
              toast.success("BOM has been created ");
              return { status: true, message: res.data.data.bom_id };
            } else {
              setBom_id(null);
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            setBom_id(null);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        setBom_id(null);
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
